const configureGoogleAnalytics4 = (measurementId) => {
    if (
        typeof google_tag_manager === 'undefined' ||
        typeof google_tag_manager[measurementId] === 'undefined'
    ) {
        var google_tag_manager = {};
        google_tag_manager[measurementId] = document.createElement('script');
        google_tag_manager[measurementId].async = 1;
        google_tag_manager[
            measurementId
        ].src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(google_tag_manager[measurementId]);
    }
};
export default configureGoogleAnalytics4;
